module.exports = __webpack_public_path__ + "img/2020-12-24.22002aac.jpg";